import { take, race, put, call, delay, fork, takeEvery, select } from 'redux-saga/effects'
import requestWithRetry from 'civic-champs-shared/api/requestWithRetry'

import { isFeatureEnabled } from '../../core/feature/selectors'
import { KIOSK_SESSION_LIFECYCLE_FEATURE_KEY } from '../kioskSessionLifecycleFeature'

import {
  KIOSK_STARTED,
  KIOSK_STOPPED,
  getWaivers,
  GET_WAIVERS,
  GET_WAIVERS_SUCCEEDED,
  GET_WAIVERS_FAILED,
  getWaiversSucceeded,
  getWaiversFailed,
} from 'kiosk/actions'
import { getEncodedOccurrence } from 'kiosk/selectors'

const BASE_POLL_MS = 1000 * 60 * 60
const MAX_POLL_MS = 1000 * 60 * 60 * 4

export default function* waiversSaga() {
  yield fork(watchGetWaivers)
  yield fork(synchronizeWaiversFlow)
}

export function* synchronizeWaiversFlow() {
  while (true) {
    yield take(KIOSK_STARTED)
    yield race([
      take(KIOSK_STOPPED),
      call(function* pollWaiversWithBackoff() {
        let pollDelayMs = BASE_POLL_MS
        while (true) {
          const lifecycleEnabled = yield select(state => isFeatureEnabled(state, KIOSK_SESSION_LIFECYCLE_FEATURE_KEY))
          yield put(getWaivers())
          if (lifecycleEnabled) {
            // Backoff between poll cycles on failure; axios retry disabled on fetch (see fetchWaivers).
            const result = yield race({
              success: take(GET_WAIVERS_SUCCEEDED),
              failed: take(GET_WAIVERS_FAILED),
            })
            pollDelayMs = result.failed ? Math.min(pollDelayMs * 2, MAX_POLL_MS) : BASE_POLL_MS
          } else {
            pollDelayMs = BASE_POLL_MS
          }
          yield delay(pollDelayMs)
        }
      }),
    ])
  }
}

export function* watchGetWaivers() {
  yield takeEvery(GET_WAIVERS, onGetWaivers)
}

export function* onGetWaivers() {
  try {
    const waivers = yield fetchWaivers()
    yield put(getWaiversSucceeded(waivers))
  } catch (error) {
    yield put(getWaiversFailed(error))
  }
}

function* fetchWaivers() {
  let opportunityId = yield select(getEncodedOccurrence)
  let url = `/opportunity_instances/${opportunityId}/credentials`
  const useRetry = !(yield select(state => isFeatureEnabled(state, KIOSK_SESSION_LIFECYCLE_FEATURE_KEY)))
  return yield call(requestWithRetry, { url }, useRetry)
}
